import type { SnippetMetadata } from 'flow/service/snippets';
import type { PaginatedRequestParams } from './libraryApi';
import type { SnippetsResponse } from './types';

export async function fetchAllPaginatedSnippets(args: {
  fetcherFn: (params: PaginatedRequestParams) => Promise<SnippetsResponse>;
}): Promise<SnippetMetadata[]> {
  const { fetcherFn } = args;

  let pageNum: PaginatedRequestParams['pageNum'] = 1;
  const pageSize: PaginatedRequestParams['pageSize'] = 100;

  const snippetMetadata: SnippetMetadata[] = [];

  let hasMoreData = false;
  do {
    // the fetcher needs to be sequentially called in a loop as the results determine the next call
    /* eslint-disable-next-line no-await-in-loop */
    const { pagination, snippets } = await fetcherFn({
      pageNum,
      pageSize,
    });

    snippetMetadata.push(...snippets);
    hasMoreData = pagination.page < pagination.total_pages;
    pageNum += 1;
  } while (hasMoreData);


  return snippetMetadata;
}
